<template>
    <span class="count cart-count">{{ count }}</span>
</template>

<script>
    export default {
        name: "CartCount",
        data() {
            return {
                state: store.state,
            }
        },
        computed: {
            count () {
                return this.state.cart.length
            }
        },
        mounted () {
            if ( !this.count ) {
                $(this.$el).attr("state-empty", true);
            } else {
                $(this.$el).attr("state-empty", false);
            }
        },
        watch: {
            count (newCount, oldCount) {
                let component = this;

                if ( !newCount ) {
                    $(this.$el).attr("state-empty", true);
                } else {
                    $(this.$el).attr("state-empty", false);

                    if (oldCount && oldCount < newCount) {
                        $(this.$el).attr("state-popping", true);
                        $(this.$el).parent().attr("state-popping", true);
                        setTimeout(function () {
                            $(component.$el).attr("state-popping", false);
                            $(component.$el).parent().attr("state-popping", false);
                        }, 800)
                    }
                }
            }
        }
    }
</script>

<style scoped>

</style>
